import { AbsoluteFill } from 'remotion'
import { BackgroundStyle } from '../types'
import { FallbackImg } from './FallbackImg'

export const Background = ({ color, image }: BackgroundStyle) => {
  return (
    <AbsoluteFill>
      {!!image && (
        <FallbackImg src={image} className="h-full w-full object-cover" />
      )}
      {!!color && <AbsoluteFill style={{ backgroundColor: color }} />}
    </AbsoluteFill>
  )
}
